module.exports = __webpack_public_path__ + "img/rana-pro.642419fb.jpg";